import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CacheInterceptor implements HttpInterceptor {
  private _cache: {
    GET: { [key: string]: HttpResponse<unknown> };
    POST: { [key: string]: HttpResponse<unknown> };
  } = { GET: {}, POST: {} };

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (req.method !== 'GET' && req.method !== 'POST') {
      return next.handle(req);
    }

    const cacheKey =
      req.method === 'GET' ? req.urlWithParams
      : req.method === 'POST' ?
        `${req.urlWithParams}:${JSON.stringify(req.body)}`
      : undefined;

    if (cacheKey && this._cache[req.method][cacheKey]) {
      return of(this._cache[req.method][cacheKey]);
    }

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this._cache[req.method as keyof typeof this._cache][cacheKey] = event;
        }
      }),
    );
  }
}
